import { CREATE_BRAND_PROJECT_ROUTE_ID } from 'root/src/shared/descriptions/routes/routeIds';
import { CREATE_BRAND_PROJECT_FORM_MODULE_ID } from 'root/src/shared/descriptions/modules/moduleIds';
import setInput from 'root/src/client/logic/form/thunks/setInput';
import canAccessCreateBrandProjectSelector from 'root/src/client/logic/dropEvent/selectors/canAccessCreateBrandProjectSelector';
import pushRouteClient from 'root/src/client/logic/route/util/pushRouteClient';
import { sentryClientObjMessage } from 'root/src/client/util/sentry';
import getUserDataSelector from 'root/src/client/logic/api/selectors/getUserDataSelector';
export const redirectToCreateBrandProjectForm = (payloadData) => (dispatch, getState) => {
    const state = getState();
    const { campaign } = payloadData;
    if (!canAccessCreateBrandProjectSelector(state)) {
        const userData = getUserDataSelector(state);
        sentryClientObjMessage('Not authorized user was redirected to /create-brand-project page', { campaignId: campaign.campaignId, userData });
        return undefined;
    }
    // TODO find some reasonable way to automate this kind of moduleKey string creation
    const formKey = `${CREATE_BRAND_PROJECT_ROUTE_ID}-${CREATE_BRAND_PROJECT_FORM_MODULE_ID}`;
    Object.keys(payloadData).forEach((key) => {
        dispatch(setInput(payloadData[key], formKey, [key]));
    });
    return pushRouteClient({ routeId: CREATE_BRAND_PROJECT_ROUTE_ID });
};
